class SysMessagesController {
    constructor(UtpSysMessagesServiceApi, UserDetailsApi, moment) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                showText: false,
                showAdd: false
            };
            this.data = {
                text: '',
                messages: []
            };
            this.userDetails.get().then((response) => {
                let connectedUser = response.data;
                this.state = {
                    showText: false,
                    showAdd: connectedUser.IsAdmin || connectedUser.IsSupport
                };
            });
            this.sysMessagesService.userMessages().then((response) => {
                this.data.messages = response.data;
            });
        };
        this.closeText = () => {
            this.state.showText = false;
            this.data.text = '';
        };
        this.markAsRead = (messageId) => {
            this.sysMessagesService.markAsRead(messageId).then((response) => {
                this.data.messages = response.data;
                if (this.data.messages.length === 0) {
                    this.close();
                }
            });
        };
        this.getFromNowString = (utcTime) => {
            let utc = this.moment.utc(utcTime);
            let local = this.moment(utc).local();
            return this.moment(local).fromNow();
        };
        this.createMessage = (message) => {
            let msg = {
                Message: message
            };
            this.sysMessagesService.createMessage(msg).then(() => {
                this.sysMessagesService.userMessages().then((response) => {
                    this.data.messages = response.data;
                    this.closeText();
                });
            });
        };
        this.sysMessagesService = UtpSysMessagesServiceApi;
        this.userDetails = UserDetailsApi;
        this.moment = moment;
    }
}
angular.module('app').component('sysMessagesModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/sysMessages/sys-messages.tpl.html',
    controllerAs: 'vm',
    controller: SysMessagesController
});
